import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import css from './css.module.less';
import React from 'react';

import { Form } from 'src/components/Antd';
import AttributesTable from 'src/pages/StoreVoucher/Detail/Components/Attributes';
//import Customer from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/CustomerTable';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Item = Form.Item;
// import { useStoreCountries } from '@/src/pages/Settings/Components/SelectCountryArea';

const Attributes = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled } = props;
  // const { list: storeCountries } = useStoreCountries();
  return (
    <SectionWrapper
      containerClassName={css.sectionContainer}
      title={getI18n('voucher.storeVoucherDetail.attributes')}
      subtitle={getI18n('voucher.storeVoucherDetail.attributesSubtitle')}>
      <Item name={'attributes'}>
        <AttributesTable disabled={disabled} />
      </Item>

      {/* <RegionTable /> */}
      {/* <Form.Item name={'countryAreas'} initialValue={[]}>
        <CheckCountry list={storeCountries} />
      </Form.Item> */}
    </SectionWrapper>
  );
};

export default Attributes;
